import React from "react";
import PropTypes from "prop-types";
import FixedBox from "./FixedBox";

function XLabels({
  labels,
  width,
  labelsVisibility,
  squares,
  height,
  yWidth,
  yLabelFormat,
}) {
  return (
    <div style={{ height: "20px" }}>
      <div
        style={{
          display: "flex",
          marginBottom: "0.5rem",
          position: "absolute",
          flex: 1,
          right: 0,
          left: 0,
        }}
      >
        <FixedBox width={yWidth} />
        {labels.map((x, i) => (
          <div
            key={i}
            style={{
              flex: squares ? "none" : 1,
              color: "#98A2BC",
              alignItems: "center",
              textAlign: "center",
              fontSize: "0.75rem",
              lineHeight: "0.75rem",
              fontFamily: "inherit",
              display:
                labelsVisibility && !labelsVisibility[i] ? "none" : "flex",
            }}
          >
            <span>{yLabelFormat ? yLabelFormat(x) : x}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

XLabels.propTypes = {
  labels: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
  ).isRequired,
  labelsVisibility: PropTypes.arrayOf(PropTypes.bool),
  width: PropTypes.number.isRequired,
  yWidth: PropTypes.number.isRequired,
  squares: PropTypes.bool,
  height: PropTypes.number,
  yLabelFormat: PropTypes.func,
};

XLabels.defaultProps = {
  labelsVisibility: null,
  squares: false,
  height: 30,
  yLabelFormat: null,
};

export default XLabels;
